import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ShopProvider } from "@/context/ShopContext";
import { Navbar } from "@/components/shop/Navbar";
import { Footer } from "@/components/shop/Footer";
import { MobileTabBar } from "@/components/shop/MobileTabBar";
import { CartSheet } from "@/components/shop/CartSheet";
import { ProtectedRoute } from "@/components/shop/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductPage from "@/pages/ProductPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderPage from "@/pages/OrderPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import { SupportPage, CollectionPage } from "@/pages/SupportPage";
import EventsPage from "@/pages/EventsPage";
import GamePage from "@/pages/GamePage";
import { ShippingPage, TrackPage, B2BPage } from "@/pages/InfoPages";
import SellPage from "@/pages/SellInfoPage";
import DeckBuilderPage from "@/pages/DeckBuilderPage";
import { AnnouncementBar } from "@/components/shop/HomeSections";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import { PrivacyPage, CookiePage, TermsPage, LegalNotesPage } from "@/pages/LegalPages";
import { ConsentGate } from "@/components/shop/ConsentGate";
import { ContentPage, NewsListPage, NewsPostPage } from "@/pages/ContentPages";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordPages";
import VerifyEmailPage from "@/pages/VerifyEmailPage";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/catalogo" element={<CatalogPage />} />
      <Route path="/prodotto/:id" element={<ProductPage />} />
      <Route path="/accedi" element={<LoginPage />} />
      <Route path="/contatti" element={<Navigate to="/assistenza#contatti" replace />} />
      <Route path="/faq" element={<Navigate to="/assistenza#faq" replace />} />
      <Route path="/assistenza" element={<SupportPage />} />
      <Route path="/pezzi-da-collezione" element={<CollectionPage />} />
      <Route path="/spedizioni" element={<ShippingPage />} />
      <Route path="/traccia" element={<TrackPage />} />
      <Route path="/b2b" element={<B2BPage />} />
      <Route path="/eventi" element={<EventsPage />} />
      <Route path="/gioco/:slug" element={<GamePage />} />
      <Route path="/vendi" element={<SellPage />} />
      <Route path="/deckbuilder" element={<DeckBuilderPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/ordine/:id" element={<OrderPage />} />
      <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute admin><AdminPage /></ProtectedRoute>} />
      <Route path="/pagamento/successo" element={<PaymentSuccessPage />} />
      <Route path="/pagamento/annullato" element={<PaymentCancelPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/cookie" element={<CookiePage />} />
      <Route path="/condizioni-di-vendita" element={<TermsPage />} />
      <Route path="/note-legali" element={<LegalNotesPage />} />
      <Route path="/pagina/:slug" element={<ContentPage />} />
      <Route path="/news" element={<NewsListPage />} />
      <Route path="/news/:slug" element={<NewsPostPage />} />
      <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
      <Route path="/reimposta-password" element={<ResetPasswordPage />} />
      <Route path="/verifica-email" element={<VerifyEmailPage />} />
      <Route path="*" element={<p className="py-32 text-center text-stone-600">Pagina non trovata.</p>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="grain min-h-screen bg-[#FFFBF3] text-stone-900">
      <BrowserRouter>
        <AuthProvider>
          <ShopProvider>
            <AnnouncementBar />
            <Navbar />
            <main className="min-h-[70vh]"><AppRouter /></main>
            <Footer />
            <MobileTabBar />
            <div className="h-16 sm:hidden" aria-hidden />
            <CartSheet />
            <ConsentGate />
            <Toaster position="bottom-center" theme="light" richColors offset={80} />
          </ShopProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
